import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getOffers = async (id) => {
    const { data } = await API.get(`api/v1/rbzo/coupon/customer/${id}`);
    return data;
};
export const useOfferById = (id) => {
    return useQuery(["venue_id_offer", id], () => getOffers(id), {
        staleTime: 10 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
    });
};
